import React, { useState } from 'react';
import './ClientTestimonials.css';

const ClientTestimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: 'Ritika Deore',
      position: 'Happy Homeowners',
      image: '/assets/img/team/user1.jpg',
      quote: 'As an investor, I\'ve worked with several construction companies over the years, but none compare to Desale Patil. Their team\'s expertise, reliability, and dedication to excellence set them apart. They guided me through every step of the process, from site selection to project completion, and delivered outstanding results that have exceeded my expectations. I\'m grateful for their professionalism and look forward to partnering with them on future projects.'
    },
    {
      id: 2,
      name: 'Rajesh Kumar',
      position: 'Business Owner',
      image: '/assets/img/team/user1.jpg',
      quote: 'Working with Desale Patil was an excellent experience. They delivered our commercial building on time and within budget. The quality of construction is top-notch, and their attention to detail is remarkable. Highly recommended for any construction project.'
    },
    {
      id: 3,
      name: 'Priya Sharma',
      position: 'Property Developer',
      image: '/assets/img/team/user1.jpg',
      quote: 'Desale Patil transformed our vision into reality. Their innovative approach and commitment to quality are exceptional. The team was professional, responsive, and delivered beyond our expectations. We couldn\'t be happier with the results.'
    }
  ];

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => 
      (prevIndex + 1) % testimonials.length
    );
  };

  const current = testimonials[currentIndex];

  return (
    <section className="testimonials-section">
      <div className="testimonials-overlay"></div>
      <div className="container">
        <div className="section-title text-center">
          <h2>Our <span>Satisfied Clients</span></h2>
        </div>
        
        <div className="testimonial-content">
          <div className="testimonial-card">
            <div className="quote-icon">
              <i className="fas fa-quote-left"></i>
            </div>
            
            <div className="testimonial-text">
              <p>"{current.quote}"</p>
            </div>
            
            <div className="client-info">
              <div className="client-image">
                <img src={current.image} alt={current.name} />
              </div>
              <div className="client-details">
                <h4>{current.name}</h4>
                <span>{current.position}</span>
              </div>
            </div>
            
            <div className="testimonial-navigation">
              <button 
                className="nav-btn prev-btn" 
                onClick={goToPrevious}
                aria-label="Previous testimonial"
              >
                <i className="fas fa-chevron-left"></i>
              </button>
              <button 
                className="nav-btn next-btn" 
                onClick={goToNext}
                aria-label="Next testimonial"
              >
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientTestimonials;
